// extracted by mini-css-extract-plugin
export default {"melodyVideo":"xL-z","isFullWidth":"yL-z","landingPageVideo":"zL-z","play":"AL-z","iframeVideo":"BL-z","playHidden":"CL-z","fullwidth":"DL-z"};